// @format
import React from 'react';
import { objOf, equals } from 'ramda';
import { compose, withStateHandlers, withProps, withHandlers } from 'recompose';

import TextField from 'material-ui/TextField';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import facialLogo from './Facialapplogo.png';
import './Form.css';

const Form = ({
  platform = 'iOS',
  'entry.1711555859': selected,
  onAgeSelected,
  sourceHandler,
  source,
  radioStyle,
  underlineStyle,
  underlineFocusStyle,
  onPlatformChangeHandler,
}) => (
  <form
    className="Form"
    action="https://docs.google.com/forms/d/e/1FAIpQLScTV1po4ZwkYt5dZKPQL3olVkjIK0kbCIW9imbQI68XZrLZ1w/formResponse"
    target="_self"
    method="POST"
    id="mG61Hd"
  >
    <img src={facialLogo} alt="logo" />
    <p>Join Facial beta program</p>

    <div className="Form-input">
      <label>Name / 姓名</label>
      <TextField
        hintText="名稱"
        name="entry.1000099178"
        fullWidth
        required
        underlineStyle={underlineStyle}
        underlineFocusStyle={underlineFocusStyle}
        autoComplete="name"
      />
    </div>
    <div className="Form-input">
      <label>你的 Email 信箱</label>
      <TextField
        type="email"
        hintText="Your email address"
        name="emailAddress"
        autoComplete="email"
        fullWidth
        required
        underlineStyle={underlineStyle}
        underlineFocusStyle={underlineFocusStyle}
      />
    </div>
    <div className="Form-input">
      <label>Nationality / 國籍</label>
      <TextField
        hintText="Nationality"
        name="entry.107547676"
        fullWidth
        required
        underlineStyle={underlineStyle}
        underlineFocusStyle={underlineFocusStyle}
        autoComplete="country-name"
      />
    </div>
    <div className="Form-input" />
    <div className="Form-input">
      <label>OS Platform / 手機平台</label>
      <RadioButtonGroup
        name="entry.1673462413"
        valueSelected={platform}
        className="Form-input-radio"
        onChange={onPlatformChangeHandler}
      >
        <RadioButton
          value="Android"
          label="Android"
          jsname="L9xHkb"
          style={radioStyle}
        />
      </RadioButtonGroup>
    </div>
    <div className="Form-input">
      <label>Gender / 性別</label>
      <RadioButtonGroup
        name="entry.958403141"
        defaultSelected="Male/男性"
        className="Form-input-radio"
      >
        <RadioButton
          jsname="L9xHkb"
          value="Male/男性"
          label="Male/男性"
          style={radioStyle}
        />
        <RadioButton
          jsname="L9xHkb"
          value="Female/女性"
          label="Female/女性"
          style={radioStyle}
        />
        <RadioButton
          jsname="L9xHkb"
          value="others/其他"
          label="others/其他"
          style={radioStyle}
        />
      </RadioButtonGroup>
    </div>
    <div className="Form-input">
      <label>Age / 年齡</label>
      <SelectField value={selected} onChange={onAgeSelected} autoWidth>
        <MenuItem value="13 歲以下" primaryText="13 歲以下" />
        <MenuItem value="13~18 歲" primaryText="13~18 歲" />
        <MenuItem value="19~24 歲" primaryText="19~24 歲" />
        <MenuItem value="25~30 歲" primaryText="25~30 歲" />
        <MenuItem value="31~35 歲" primaryText="31~35 歲" />
        <MenuItem value="35~40 歲" primaryText="35~40 歲" />
        <MenuItem value="40~50 歲" primaryText="40~50 歲" />
        <MenuItem value="50~60 歲" primaryText="50~60 歲" />
        <MenuItem value="60 歲以上" primaryText="60 歲以上" />
      </SelectField>
      <input
        type="hidden"
        name="entry.1711555859"
        jsname="L9xHkb"
        value={selected}
        required
      />
    </div>
    <div className="Form-input field-source">
      <label>Where did you get this link / 從哪裡得到此連結</label>
      <RadioButtonGroup
        name="entry.2615270"
        defaultSelected="Instagram"
        onChange={sourceHandler}
      >
        <RadioButton
          jsname="L9xHkb"
          value="Instagram"
          label="Instagram"
          style={radioStyle}
        />
        <RadioButton
          jsname="L9xHkb"
          value="Friends"
          label="Friends"
          style={radioStyle}
        />
        <RadioButton
          jsname="L9xHkb"
          value="__other_option__"
          label=" Others:"
          style={radioStyle}
        />
      </RadioButtonGroup>
      <TextField
        name="entry.2615270.other_option_response"
        jsname="MfYA1e"
        required={equals('__other_option__', source)}
        underlineStyle={underlineStyle}
        underlineFocusStyle={underlineFocusStyle}
      />
    </div>
    <input type="submit" className="Form-submit" value="Submit" />
  </form>
);

export default compose(
  withStateHandlers(
    {
      'entry.1711555859': '13~18 歲',
      source: undefined,
    },
    {
      onAgeSelected: props => (event, index, value) => {
        console.log('CHUCK', event);
        return objOf('entry.1711555859')(value);
      },
      sourceHandler: props => (event, value) => ({
        source: value,
      }),
    },
  ),
  withHandlers({
    onPlatformChangeHandler: props => (event, value) => {
      props.setPlatform(value);
    },
  }),
  withProps({
    radioStyle: {
      marginBottom: '10px',
    },
    underlineStyle: {
      borderColor: '#9B9B9B',
    },
    underlineFocusStyle: {
      borderColor: '#4380F6',
    },
  }),
)(Form);



// WEBPACK FOOTER //
// ./src/modules/components/Form/Form.js